import { Button } from "reactstrap";
import { callFunctionIfExists } from "utils/GeneralUtils";

const ReferenceHeader = ({ name, onClose }) => {
  return (
    <div className=" border-bottom border-superlight">
      <div className="d-flex align-items-center justify-content-between p-2">
        <h5 className="text-dark m-0">{name}</h5>
        <Button
          size="sm"
          outline
          color="secondary"
          onClick={(e) => {
            e.preventDefault();
            callFunctionIfExists(onClose);
          }}
        >
          Done
        </Button>
      </div>
    </div>
  );
};

export default ReferenceHeader;
